import { AppState } from 'core/reducers/RootReducer';
import { createSelector } from 'reselect';

const getIsIssueSent = (state: AppState): boolean => state.email.isIssueSent;

export const getIsIssueSentSelector = createSelector(getIsIssueSent, (user) => user);
